import React from 'react';
import {useTranslation} from "react-i18next";
import GridFilterPanelLayoutCollapse
    from "../../../../uiLayouts/GridFilterPanelLayout/components/GridFilterPanelLayoutCollapse/GridFilterPanelLayoutCollapse";
import cl from "../../AccessSettings/AccessSettings.module.css";
import FilterPanelTagsFilterContent from "./FilterPanelTagsFilterContent";
import {SelectModel} from "../../../../../app/types/SelectModel";
import Icon from "../../../../../assets/icon/Icon";
import FilterPanelTagsFilterSelectedContainer from "./FilterPanelTagsFilterSelectedContainer";

type FilterPanelTagsFilterProps = {
    id: string;
    type: 'release' | 'quote' | 'shipment';
    disabled?: boolean;
    onClear: (value?: string) => void;
    onChange: (value: Array<SelectModel>) => void,
    value: Array<SelectModel>;
};

const FilterPanelTagsFilter: React.FC<FilterPanelTagsFilterProps> = ({
                                                                         id,
                                                                         type,
                                                                         disabled,
                                                                         onClear,
                                                                         onChange,
                                                                         value
                                                                     }) => {
    const {t} = useTranslation();

    return (
        <GridFilterPanelLayoutCollapse titleBold={false}
                                       defaultExpanded={false}
                                       showSeparationHeaderLine={false}
                                       hideOnFilterPanelLayoutContextClear={true}
                                       style={{margin: '5px 0 10px 0'}}
                                       tagsContainer={<FilterPanelTagsFilterSelectedContainer id={`${id}-tags`}
                                                                                              value={value}
                                                                                              onClear={onClear}/>}
                                       title={
                                           <>
                                               <div>
                                                   {t("tags.labels.tags")}
                                               </div>
                                               <div>
                                                   {value.length > 0
                                                       ? <Icon icon={"faTrash"}
                                                               className={cl.trash}
                                                               onClick={(ev) => {
                                                                   ev.stopPropagation();

                                                                   if (disabled) {
                                                                       return;
                                                                   }

                                                                   onClear();
                                                               }}/>
                                                       : null
                                                   }
                                               </div>
                                           </>
                                       }>
            {({isExpanded}) =>
                <div>
                    {isExpanded
                        ? <FilterPanelTagsFilterContent id={id}
                                                        type={type}
                                                        onChange={onChange}
                                                        value={value}/>
                        : <div style={{height: '250px'}}>
                        </div>
                    }
                </div>
            }
        </GridFilterPanelLayoutCollapse>
    );
};

export default FilterPanelTagsFilter;